import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginExternalComponent } from './pages/login-external/login-externalcomponent';
import { AuthGuard } from './core/guard/auth.guard';
import { LoadingComponent } from './pages/loading/loading.component';


const routes: Routes = [
  { path: 'loginInterno', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: 'login', component: LoginExternalComponent },
  { path: 'loading', component: LoadingComponent },
  { path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  { path: 'public', loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule) },
  { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
